<template>
  <div>
    <CustomerInfo v-bind:customer="customer" :loaded="customerLoaded" />

    <div v-if="customerLoaded">
      <CustomerHistory :history="customer.history" />
      <div class="grid gap-4 px-4 sm:px-6 lg:mx-auto lg:px-8 grid-cols-3">
        <div class="col-span-3">
          <CustomerOrders :customer="customer" />
        </div>
      </div>
    </div>

    <!-- No Customer loaded -->
    <div v-else>
      <div v-if="customerSearching" class="flex items-center space-x-2">
        <span>Searching</span>
        <LoadingSpinner class="text-gray-400" />
      </div>
      <div v-else>
        No Customer Loaded
      </div>
    </div>
  </div>
</template>
<script>
/**
 * TODO
 */

import CustomerInfo from "./components/CustomerInfo.vue";
import CustomerHistory from "./components/CustomerHistory.vue";
import CustomerOrders from "./components/CustomerOrders.vue";

export default {
  name: "Details",
  data() {
    return {
      slideoverVisibleEdit: false,
      slideoverVisibleSearch: false,
      services: [],
      customerHistory: {}
    };
  },
  props: {
    customerId: {
      type: Number,
      default: null
    }
  },
  created() {
    if (this.$route.params.id) {
      this.$store.dispatch("customers/fetchCustomer", this.$route.params.id);
    }
  },
  components: {
    CustomerInfo,
    CustomerHistory,
    CustomerOrders
  },
  computed: {
    customerLoaded() {
      return this.$store.getters["customers/isCustomerLoaded"];
    },
    customerSearching() {
      return this.$store.getters["customers/isCustomerSearching"];
    },
    customer() {
      return this.$store.getters["customers/getCustomer"];
    }
  },
  beforeMount() {},
  mounted() {
    this.services = [
      this.getGiftcards(),
      this.getIncontact()
    ];
  },
  methods: {},
  filters: {}
};
</script>
